// URL paths and page headings stay Czech: they are user-visible, like every other label.

private const val HISTORY_PREFIX = "historie/"

/** One screen of the app, carrying its own URL path and heading (SPECIFIKACE.md ch. 8). */
sealed class Screen(val path: String, val title: String) {
    data object DailyEntry : Screen("/", "Denní zápis")
    data object Grid : Screen("/tabulka", "Tabulkový mód")
    data object Leaderboard : Screen("/zebricek", "Žebříček")
    data object Challenges : Screen("/vyzvy", "Výzvy")
    data object Statistics : Screen("/statistiky", "Statistiky")
    data object Admin : Screen("/administrace", "Administrace")
    data class History(val participantId: String) : Screen("/$HISTORY_PREFIX$participantId", "Historie")
}

/** Maps a browser path back to a screen; anything unrecognised lands on the daily entry form. */
fun screenForPath(path: String): Screen = when (val trimmed = path.trim('/')) {
    Screen.Grid.path.trim('/') -> Screen.Grid
    Screen.Leaderboard.path.trim('/') -> Screen.Leaderboard
    Screen.Challenges.path.trim('/') -> Screen.Challenges
    Screen.Statistics.path.trim('/') -> Screen.Statistics
    Screen.Admin.path.trim('/') -> Screen.Admin
    else -> if (trimmed.startsWith(HISTORY_PREFIX)) {
        Screen.History(trimmed.removePrefix(HISTORY_PREFIX))
    } else {
        Screen.DailyEntry
    }
}
